import { Storage } from '../../core/platform-interfaces/storage'

export class BrowserStorage implements Storage {
  getItem(key: string): string | null {
    return localStorage.getItem(key)
  }
  setItem(key: string, value: unknown) {
    localStorage.setItem(key, String(value))
  }
}
